/* eslint @typescript-eslint/naming-convention: 0 */
import { buildSelectTagInSearchModalParams } from '@/wabunka-src/common/utils/googleAnalytics/common/selectTag';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export const sendGAWabunkaSelectThemeInSearchModalEvent = (tag: string) => {
  sendWabunkaGAEvent('select_theme_in_search_modal', buildSelectTagInSearchModalParams(tag));
};
